// src/components/GlobalToast.jsx

import React, { useEffect, useRef, useState } from "react";

export default function GlobalToast({
  message,
  show,
  duration = 3000,
  onClose,
}) {
  const [visible, setVisible] = useState(show);
  const [progress, setProgress] = useState(100);
  const timerRef = useRef();

  useEffect(() => {
    if (show) {
      setVisible(true);
      setProgress(100);
      let start = Date.now();
      timerRef.current = setInterval(() => {
        let elapsed = Date.now() - start;
        let percent = Math.max(0, 100 - (elapsed / duration) * 100);
        setProgress(percent);
        if (elapsed >= duration) {
          setVisible(false);
          clearInterval(timerRef.current);
          if (onClose) onClose();
        }
      }, 30);
    } else {
      setVisible(false);
      setProgress(0);
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [show, duration, onClose]);

  if (!visible) return null;

  return (
    <div
      id="global-toast"
      style={{
        position: "fixed",
        top: 32,
        right: 32,
        maxWidth: 340,
        background: "var(--surface-bg-elevated)",
        color: "var(--interactive-fg)",
        padding: "12px 24px 20px 24px",
        borderRadius: "12px",
        fontSize: 16,
        fontWeight: 500,
        zIndex: 9999,
        boxShadow: "0 0 18px color-mix(in srgb, var(--interactive-fg) 55%, transparent)",
        pointerEvents: "none",
        lineHeight: 1.3,
        textAlign: "left",
        margin: 0,
        opacity: visible ? 1 : 0,
        transition: "opacity 0.3s cubic-bezier(.4,0,.2,1)",
        overflow: "hidden",
      }}
      role="alert"
      aria-live="polite"
    >
      {message}
      <div
        style={{
          position: "absolute",
          left: 0,
          bottom: 0,
          height: 4,
          width: "100%",
          background: "var(--surface-bg-muted)",
          borderRadius: "0 0 12px 12px",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            background:
              "linear-gradient(90deg, var(--interactive-fg) 0%, var(--accent-secondary) 100%)",
            transition: "width 0.07s linear"
          }}
        />
      </div>
    </div>
  );
}
